import {
  GET_SESSION,
  SET_SUBSCRIBED,
  SET_SIGNALRCONNECTED,
  SET_SESSION_HELPER
} from "./sessionActionTypes";

const sessionReducer = (state, action) => {
  switch (action.type) {
    case GET_SESSION:
      return { ...state, session: action.payload };
    case SET_SUBSCRIBED:
      return { ...state, subscribed: action.payload };
    case SET_SIGNALRCONNECTED:
      return { ...state, signalRConnected: action.payload }
    case SET_SESSION_HELPER:
      return { ...state, helper: action.payload }
    default:
      return state;
  }
};


export default sessionReducer;
